import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import { useContext, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { LoadingDot } from '../../components/images/loading/LoadingDot';
import { WebSocketContext } from '../../contexts/WebSocketContext';
import { useNavigatorOnLine } from '../../hooks/useNavigatorOnLine';
import {
    ROUTE_LOBBY,
    ROUTE_RELOAD,
    ROUTE_ROOT,
    ROUTE_THANKS4PLAY,
} from '../../models/Route';
import { getGameState } from '../games/selector';
import { routeSliceActions } from '../routeController/slice';

export const ReconnectLayer = () => {
    const onlineState = useNavigatorOnLine();
    const dispatch = useDispatch();
    const {
        hasLogin: { current },
    } = useContext(WebSocketContext);
    const offlineState = useRef<boolean>(false);

    const location = useLocation();
    const { online: socketOnline, notToReconnect } = useSelector(getGameState);

    //iOS have issue, command out 15/07/2025
    // useEffect(() => {
    //     if (!onlineState) {
    //         //mark browser offline but socket close state not updated
    //         offlineState.current = true;
    //     }
    // }, [onlineState]);
    // useEffect(() => {
    //     offlineState.current = false;
    // }, [socketOnline]);

    const isOpen = useMemo(() => {
        if (notToReconnect) {
            return false;
        } else {
            console.log(
                'app::network::',
                socketOnline,
                onlineState,
                offlineState.current
            );
            return (
                (!socketOnline || !onlineState || offlineState.current) &&
                location.pathname != ROUTE_ROOT &&
                location.pathname != ROUTE_THANKS4PLAY &&
                current == true
            );
        }
    }, [socketOnline, notToReconnect, onlineState, current]);

    useEffect(() => {
        if (
            !isOpen &&
            location.pathname !== ROUTE_LOBBY &&
            location.pathname != ROUTE_ROOT &&
            location.pathname != ROUTE_RELOAD
        ) {
            // dispatch(routeSliceActions.goto(ROUTE_LOBBY));
            dispatch(routeSliceActions.refreshTo(location.pathname));
        }
    }, [isOpen]);
    return (
        <Dialog
            fullScreen
            open={isOpen}
            disableEscapeKeyDown
            PaperProps={{
                style: {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            }}
        >
            <Stack
                alignItems={'center'}
                justifyContent={'center'}
                width={'100%'}
                height={'100%'}
            >
                {!notToReconnect && <LoadingDot width={120} />}
            </Stack>
        </Dialog>
    );
};
